// extracted by css-extract-rspack-plugin
export default {"Flash":"DiscussionTemplateBanner-module__Flash__WVvtx"};